export default {
  namespaced: true,
  state: {
    data: []
  }
};
